module.exports = __webpack_public_path__ + "img/logo02.7dd3bdc1.svg";